export enum URSSAF {
  SELECT = "urssafSelect",
  SELECT_RADIO = "urssafSelectRadio",
  INFO_MESSAGE = "urssafInfoMessage",
}

export enum URSSAF_FORM {
  GENDER = "urssafGender",
  BIRTH_NAME = "urssafBirthName",
  LAST_NAME = "urssafLastName",
  FIRST_NAME = "urssafFirstName",
  DATE_OF_BIRTH = "urssafDateOfBirth",
  DATE_OF_BIRTH_LABEL = "urssafDateOfBirthLabel",
  COUNTRY_OF_BIRTH = "urssafCountryOfBirth",
  COMMUNE_OF_BIRTH = "urssafCommuneOfBirth",
  POSTAL_CODE = "urssafPostalCode",
  LANE_TYPE = "urssafLaneType",
  LANE_NUMBER = "urssafLaneNumber",
  STREET_NAME = "urssafStreetName",
  LANE_LETTER = "urssafLaneLetter",
  ADDITIONAL_ADDRESS = "ursaffNumber",
  MOBILE_PHONE = "urssafMobilePhone",
  EMAIL = "urssafEmail",
  TITLE = "urssafTitle",
  ACCOUNT_HOLDER_NAME = "urssafAccountHolderName",
  ACCOUNT_HOLDER_SURNAME = "urssafAccountHolderSurname",
  BIC = "urssafBIC",
  ACCOUNT_NUMBER = "urssafAccountNumber",
  SUBMIT_BUTTON = "urssafSubmitButton",
  CANCEL_BUTTON = "urssafCancelButton",
}

export enum URSSAF_FORM_ERRORS {
  GENDER = "urssafGenderRequiredError",
  BIRTH_NAME = "urssafBirtNameRequiredError",
  FIRST_NAME = "urssafFirstNameRequiredError",
  DATE_OF_BIRTH = "urssafDateOfBirthRequiredError",
  COUNTRY_OF_BIRTH = "urssafCountryOfBirthRequiredError",
  POSTAL_CODE = "urssafPostalCodeRequiredError",
  LANE_TYPE = "urssafLaneTypeRequiredError",
  LANE_NUMBER = "urssafLaneNumberRequiredError",
  STREET_NAME = "urssafStreetNameRequiredError",
  MOBILE_PHONE = "urssafMobilePhoneRequiredError",
  EMAIL = "urssafEmailRequiredError",
  TITLE = "urssafTitleRequiredError",
  ACCOUNT_HOLDER_NAME = "urssafAccountHolderNameRequiredError",
  ACCOUNT_HOLDER_SURNAME = "urssafAccountHolderSurnameRequiredError",
  BIC = "urssafBICRequiredError",
  ACCOUNT_NUMBER = "urssafAccountNumberRequiredError",
}

export enum URSSAF_PROFILE_STATUS {
  HEADER = "urssafProfileStatusHeader",
  LOGO = "urssafProfileStatusLogo",
  STATUS = "urssafProfileStatus",
  BUTTON = "urssafProfileStatusButton",
}
